import * as React from 'react';

// Components
import { MonthPickerInput, CustomMonthPickerInputProps } from './MonthPickerInput';

export const YearMonthPickerInput: React.FC<CustomMonthPickerInputProps> = ({ ...props }) => {
    return <MonthPickerInput showCalendarHeader={true} valueFormat={'MMMM YYYY'} {...props} />;
};
